// Values from docs/analytics/proposals/2026-09-15-s601-free-tier-soft-wall-upgrade-funnel.md
// Event names must match ANALYTICS_EVENTS; analytics.constants.ts asserts it.
export const UPGRADE_FUNNEL_BROWSER_EVENTS = [
  'paywall_viewed',
  'upgrade_clicked',
  'checkout_started',
  'quota_warning_shown',
] as const;
export type UpgradeFunnelBrowserEvent =
  (typeof UPGRADE_FUNNEL_BROWSER_EVENTS)[number];

// Named access so the web app never spells an event name as a literal.
export const UPGRADE_FUNNEL_BROWSER_EVENT = {
  PAYWALL_VIEWED: 'paywall_viewed',
  UPGRADE_CLICKED: 'upgrade_clicked',
  CHECKOUT_STARTED: 'checkout_started',
  QUOTA_WARNING_SHOWN: 'quota_warning_shown',
} as const satisfies Record<string, UpgradeFunnelBrowserEvent>;

export const UPGRADE_TRIGGERS = [
  'quota_exhausted',
  'calendar_add_attempt',
  'banner_click',
  'settings',
  'pricing_page',
  'email',
  'pre_wall_warning',
  'subscription_ended',
] as const;
export type UpgradeTrigger = (typeof UPGRADE_TRIGGERS)[number];

export const QUOTA_WARNING_CHANNELS = ['in_app', 'email'] as const;
export type QuotaWarningChannel = (typeof QUOTA_WARNING_CHANNELS)[number];

export const PAYWALL_SURFACES = [
  'first_login_modal',
  'plans_tab',
  'plans_page',
] as const;
export type PaywallSurface = (typeof PAYWALL_SURFACES)[number];

export const PLANS_SURFACES = [
  'plans_tab',
  'plans_page',
] as const satisfies readonly PaywallSurface[];
export type PlansSurface = (typeof PLANS_SURFACES)[number];

export const PAYWALL_DISPLAYS = ['user_click', 'programmatic'] as const;
export type PaywallDisplay = (typeof PAYWALL_DISPLAYS)[number];

export const UPGRADE_SOURCE_ELEMENTS = [
  'banner',
  'dashboard_plan_card',
  'first_login_modal_cta',
  'sidebar_unlock_calendars',
  'sidebar_locked_calendar',
  'calendars_tab_unlock',
  'calendars_tab_locked_row',
  'event_card_hover',
  'event_editor',
  'appointment_type_editor',
  'addon_event_card',
  'settings_nav',
  'email_link',
  'pricing_page_link',
  'pre_wall_warning_banner',
  'pre_wall_warning_email',
] as const;
export type UpgradeSourceElement = (typeof UPGRADE_SOURCE_ELEMENTS)[number];

export const UPGRADE_SOURCE_PAGES = [
  'dashboard',
  'settings',
  'calendars_tab',
  'booking_settings',
  'addon',
  'external',
  'other',
] as const;
export type UpgradeSourcePage = (typeof UPGRADE_SOURCE_PAGES)[number];

export const UPGRADE_ACCOUNT_STATES = [
  'free_active',
  'free_exhausted',
  'paid',
  'subscription_ended',
] as const;
export type UpgradeAccountState = (typeof UPGRADE_ACCOUNT_STATES)[number];

export const UPGRADE_BILLING_INTERVALS = ['month', 'year'] as const;
export type UpgradeBillingInterval = (typeof UPGRADE_BILLING_INTERVALS)[number];

export const UPGRADE_ACTIONS = ['new_checkout', 'plan_change'] as const;
export type UpgradeAction = (typeof UPGRADE_ACTIONS)[number];
